import * as React from 'react';
import { Component } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import { TrainingCourseService } from '../../services/TrainingCourseService';
import { ITrainingCourse } from '../../models/ITrainingCourse';
import { IDropDownItem } from '../../models/IDropDownItem';
import { SimpleSelectComponent } from '../../controls/SimpleSelect';
import { LoaderComponent } from '../../controls/Loader';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { ShowStatusBar, ShowErrorStatus } from '../Layout/GlobalStatusBar';


interface IProps {
    IsEditMode: boolean,
    TrainingCourses: ITrainingCourse[],
    OnRefreshRequired: () => void
}

interface IState {
    EditTrainingCourses: boolean,
    NewTrainingCourseName?: string,
    NewTrainingCourseYear?: number,
    AllTrainingCourses: IDropDownItem[],
    TrainingCourses: IDropDownItem[],
    LoaderVisible: boolean
}

export class TrainingCoursesComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            EditTrainingCourses: false,
            TrainingCourses: [],
            AllTrainingCourses: [],
            LoaderVisible: false
        }

        this.OnTrainingCourseSubmit = this.OnTrainingCourseSubmit.bind(this);
        this.OnTrainingCourseAbort = this.OnTrainingCourseAbort.bind(this);
        this.OnAddTrainingCourse = this.OnAddTrainingCourse.bind(this);
        this.OnInputChange = this.OnInputChange.bind(this);
        this.OnAddTrainingCourseSuccess = this.OnAddTrainingCourseSuccess.bind(this);
        this.OnAddTrainingCourseError = this.OnAddTrainingCourseError.bind(this);       
        this.OnTrainingCourseDeleteSuccess = this.OnTrainingCourseDeleteSuccess.bind(this);
        this.OnTrainingCourseDeleteError = this.OnTrainingCourseDeleteError.bind(this);
        this.GetAllTrainingCourses = this.GetAllTrainingCourses.bind(this);
        this.OnGetAllTrainingCoursesSuccess = this.OnGetAllTrainingCoursesSuccess.bind(this);
        this.OnGetAllTrainingCoursesError = this.OnGetAllTrainingCoursesError.bind(this);
        this.OnTrainingCourseSelected = this.OnTrainingCourseSelected.bind(this);
        this.OnTrainingCourseValueChange = this.OnTrainingCourseValueChange.bind(this);
        this.OnTrainingCoursesDataRefreshRequired = this.OnTrainingCoursesDataRefreshRequired.bind(this);

        if (this.props.IsEditMode) {
            this.GetAllTrainingCourses();
        }
    }

    public componentWillReceiveProps(nextProps: IProps) {
        this.setState({
            LoaderVisible: false
        });
    }

    public render() {
        let itemsElement: null | JSX.Element = null;
        let buttons: null | JSX.Element = null;
        if (this.state.EditTrainingCourses) {
            buttons = (
                <div className="buttons">
                    <button className="std-secondary-btn" onClick={this.OnTrainingCourseAbort}>Anuluj</button>
                    <button type="submit" className="std-primary-btn">Zapisz</button>
                </div>
            );
            itemsElement = (
                <div className="input">
                    <form onSubmit={this.OnTrainingCourseSubmit}>
                        <FormGroup>
                            <FormControl 
                                name="NewTrainingCourseYear" 
                                type="number"
                                placeholder="Rok"
                                onChange={this.OnInputChange} />
                            <SimpleSelectComponent
                                Items={this.state.TrainingCourses}
                                OnItemSelected={this.OnTrainingCourseSelected}
                                OnValueChange={this.OnTrainingCourseValueChange}
                                OnDataRefreshRequired={this.OnTrainingCoursesDataRefreshRequired}
                                Placeholder="Wybierz kurs z listy lub dodaj własny"
                                DropDownLabel="Dodaj własny kurs"
                                CollapseOnDropDownLabelClick={true} />
                        </FormGroup>
                        {buttons}
                    </form>
                </div>
            );
        } else {
            if (this.props.IsEditMode) {
                buttons = (
                    <div className="buttons">
                        <a onClick={this.OnAddTrainingCourse}>Dodaj kurs</a>
                    </div>
                );
            }
            let items: JSX.Element[] = [];
            if (this.props.IsEditMode) {
                items = this.props.TrainingCourses.map((course) => (
                    <li key={course.Id}>
                        <span className="course-name">
                            <b>{course.Year ? (course.Year + ' - ') : null}</b>
                            {course.Name}
                            {
                                (course.NeedAcceptance === true) ?
                                    (<b className="need-acceptance">&nbsp;(do akceptacji przez administratora)</b>) :
                                    null
                            }
                        </span>
                        <a className="delete-icon" onClick={this.OnTrainingCourseDelete.bind(this, course.Id)}>&nbsp;</a>
                    </li>
                ));
            } else {
                items = this.props.TrainingCourses.filter((i, index) => i.NeedAcceptance !== true).map((course) => (
                    <li key={course.Id}>
                        <span className="course-name">
                            <b>{course.Year ? (course.Year + ' - ') : null}</b>
                            {course.Name}
                        </span>
                    </li>
                ));
            }

            itemsElement = (
                <div className="input">
                    <LoaderComponent Visible={this.state.LoaderVisible} />
                    {
                        (this.props.TrainingCourses.find(tc => tc.NeedAcceptance === true) !== undefined && this.props.IsEditMode) ?
                            (<div className="info">
                                <p>
                                    Niektóre kursy zostały niedawno dodane do bazy danych i wymagają akceptacji przez administrację portalu.
                                </p>
                            </div>) :
                            null
                    }
                    {
                        items.length > 0 ?
                            (<ul className="courses-list">
                                {items}
                            </ul>) :
                            null
                    }
                    {buttons}
                </div>
            );
        }
        return (
            <div className="form-row courses">
                <label>Ukończone szkolenia:</label>
                {itemsElement}
            </div>
        );
    }//end-of-render

    private OnInputChange(event) {
        let partialState = {};
        partialState[event.target.name] = event.target.value;
        this.setState(partialState);
    }

    private OnTrainingCourseAbort(evt) {
        this.setState({
            EditTrainingCourses: false
        });
    }

    private OnAddTrainingCourse(evt) {
        this.setState({
            EditTrainingCourses: true
        });
    }

    private OnTrainingCourseSubmit(evt) {
        let service = new TrainingCourseService();
        service.AddMyTrainingCourse({
                Name: this.state.NewTrainingCourseName,
                Year: this.state.NewTrainingCourseYear,
                NeedAcceptance: true
            }, this.OnAddTrainingCourseSuccess,
            this.OnAddTrainingCourseError);
        this.setState({
            EditTrainingCourses: false,
            NewTrainingCourseYear: undefined,
            NewTrainingCourseName: undefined,
            LoaderVisible: true
        });
        evt.preventDefault();
    }

    private OnAddTrainingCourseSuccess(result) {
        this.props.OnRefreshRequired();
        ShowStatusBar('Success', 'Zaktualizowano listę kursów', DEFAULT_STATUS_TIMEOUT);
    }

    private OnAddTrainingCourseError(error) {
        //console.error(error);
        //let errorMessage = 'Nie udało się zaktualizować listy kursów. Spróbuj ponownie.';
        //if (error.response) {
        //    if (error.response.data) {
        //        errorMessage = error.response.data;
        //    }
        //}
        //ShowStatusBar('Error', errorMessage, DEFAULT_STATUS_TIMEOUT);
        ShowErrorStatus(error, 'Nie udało się zaktualizować listy kursów. Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
        this.setState({
            LoaderVisible: false
        });
    }

    private OnTrainingCourseDelete(id: number, evt) {
        this.setState({
            LoaderVisible: true
        });
        let service = new TrainingCourseService();
        service.RemoveMyTrainingCourse(id, this.OnTrainingCourseDeleteSuccess, this.OnTrainingCourseDeleteError);
    }

    private OnTrainingCourseDeleteSuccess(result) {
        ShowStatusBar('Success', 'Kurs usunięty', DEFAULT_STATUS_TIMEOUT);
        this.props.OnRefreshRequired();
    }

    private OnTrainingCourseDeleteError(error) {
        console.error(error);
        ShowStatusBar('Error', 'Nie udało się usunąć kursu. Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
        this.setState({
            LoaderVisible: false
        });
    }

    private GetAllTrainingCourses() {
        let service = new TrainingCourseService();
        service.GetAllTrainingCourses(this.OnGetAllTrainingCoursesSuccess, this.OnGetAllTrainingCoursesError);
    }

    private OnGetAllTrainingCoursesSuccess(result) {
        let courses = result.data.Value as ITrainingCourse[];
        let dropDownItems: IDropDownItem[] = [];
        let allDropDownItems: IDropDownItem[] = [];
        for (let course of courses) {
            let newDropDownItem = {
                Id: course.Id,
                Value: course.Name ? course.Name : ''
            }
            dropDownItems.push(newDropDownItem);
            allDropDownItems.push(newDropDownItem);
        }
        this.setState({
            TrainingCourses: dropDownItems,
            AllTrainingCourses: allDropDownItems
        });
    }

    private OnGetAllTrainingCoursesError(error) {
        console.error(error);
    }

    private OnTrainingCourseSelected(selectedItem: IDropDownItem) {
        this.setState({
            NewTrainingCourseName: selectedItem.Value,
            TrainingCourses: this.state.AllTrainingCourses
        });
    }

    private OnTrainingCourseValueChange(evt) {
        this.setState({
            NewTrainingCourseName: evt.target.value
        });
    }

    private OnTrainingCoursesDataRefreshRequired(searchVal: string) {
        let dropDownItems: IDropDownItem[] = [];
        for (let item of this.state.AllTrainingCourses) {
            if (item.Value.toLocaleLowerCase().indexOf(searchVal.toLocaleLowerCase()) !== -1) {
                dropDownItems.push(item);
            }
        }
        this.setState({
            TrainingCourses: dropDownItems
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/TrainingCourses.tsx